import { KEY_REDUCER_TOC } from "./constants";

export const selectorTocItems = (state) => state[KEY_REDUCER_TOC].items;
